import { render, staticRenderFns } from "./GroupTool.vue?vue&type=template&id=b4f55cee"
import script from "./GroupTool.vue?vue&type=script&lang=js"
export * from "./GroupTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports